import template from "./pClient.html";

export function pClientDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pClientController,
    controllerAs: 'pClient',
    bindToController: true
  };

  return directive;
}

class pClientController {
  constructor(Admin, Auth, $routeParams, $q, bModal, $translate, $scope, $interval, Notes, ConnectionQuality) {
    'ngInject';
    this.Auth = Auth;
    this.Admin = Admin;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.bModal = bModal;
    this.$translate = $translate;
    this.$interval = $interval;
    this.$scope = $scope;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.tooltip = {
      clients: {
        name: {
          info: this.$translate.instant("TOOLTIP.LOCAL_NAME_TOOLTIP")
        }
      }
    };

    this.valuesFields = {
      clientLabel: "info",
      clientValue: "info"
    };

    this.valuesActions = [
      {
        name: "add_processes",
        functionName: "startAddingProcesses",
        fa: "fa-plus"
      }
    ];

    this.fields = {
      idName: "info",
      name: "info",
      commentRequired: "info",
      hasVolume: "info",
      valueAdded: "value_added"
    };

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingProcess",
        fa: "fa-pencil-alt"
      }
    ];

    this.editProcessData = {
      name: {
        type: "text",
        editionDisabled: true
      },
      idName: {
        type: "text",
        editionDisabled: true
      },
      commentRequired: {
        type: "checkbox",
        isNotRequired: true
      },
      hasVolume: {
        type: "checkbox",
        isNotRequired: true
      },
      valueAdded: {
        type: "checkbox",
        isNotRequired: true
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;

        let promises = [this.Admin.getClientWithConfiguration(this.$routeParams.teamId, this.$routeParams.clientId), this.Admin.getTeam(this.$routeParams.teamId), this.Admin.getCountry(this.$routeParams.name), this.Admin.getGroups()];
        this.$q.all(promises).then(
          (success) => {
            this.client = success[0].data.client;
            if (this.client.additionalInfo)
              this.client.clientNameWithAdditionalInfo = `(${this.client.additionalInfo}) ${this.client.name}`;
            if(this.client.name == "Internal") {
              this.clientData = [
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.NAME"),
                  clientValue: this.client.name
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.COUNTRY"),
                  clientValue: this.client.country
                }
              ];

              if(this.user.isLocalAdmin) {
                delete this.valuesActions;
              }
            } else {
              this.clientData = [
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.NAME"),
                  clientValue: this.client.name
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.ADDITIONAL_INFO"),
                  clientValue: this.client.additionalInfo
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.TAX_ID"),
                  clientValue: this.client.taxId
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.COUNTRY"),
                  clientValue: this.client.country
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.GROUP_NAME"),
                  clientValue: this.client.clientGroupName
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.DEFAULT_BILLING_TYPE"),
                  clientValue: this.client.defaultBillingTypeName
                },
                {
                  clientLabel: this.$translate.instant("ADMIN_CLIENT.MULTISELECT_KEYWORDS"),
                  clientValue: this.client.multiselectKeywords && this.client.multiselectKeywords.join(", ")
                }
              ];
            }
            this.configurations = success[0].data.configurations;

            this.configurations.forEach(c => {
              c.groupConfiguration.idName = success[3].data.find(g => g.id === c.groupConfiguration.processGroupId).name || c.groupConfiguration.name;
            });

            this.configurations.forEach(c => {
              c.processConfigurations.sort((a, b) => {
                if (a.process.name < b.process.name) {
                  return -1;
                }
                if (a.process.name > b.process.name) {
                  return 1;
                }

                return 0;
              });
              c.processConfigurations.forEach(pc => {
                pc.processClientConfiguration.name = pc.process.name;
                pc.processClientConfiguration.idName = pc.process.idName;
                for (var key in pc.processClientConfiguration) {
                  pc[key] = pc.processClientConfiguration[key];
                }
                delete pc.process;
                delete pc.processClientConfiguration;
              });
            });
            this.processesToAdd = [];

            this.processGroupCountryConfigs = success[2].data.processGroupCountryConfigs;
            let processPromises = [];
            this.otherProcessClientConfigurations = [];
            this.processGroupCountryConfigs.forEach(p => processPromises.push(this.Admin.getGroupCountryConfigurations(p.id)));
            this.$q.all(processPromises).then(
              (success) => {
                success.forEach(s => {
                  if (s.data.processes.length > 0 && !this.configurations.find(c => c.groupConfiguration.id == s.data.processGroupCountryConfiguration.id)) {
                    s.data.groupConfiguration = s.data.processGroupCountryConfiguration;
                    delete s.data.processGroupCountryConfiguration;
                    this.otherProcessClientConfigurations.push(s.data);
                    this.otherProcessClientConfigurations = this.otherProcessClientConfigurations.filter(opgc => opgc.idName != "Internal");
                  }
                });
              },
              (error) => {
                this.state = 'loaded';
                this.Notes.postNote({type: "error", error: error});
              }
            );

            this.sideBarConfig = {
              "country": this.$routeParams.name,
              "team": success[1].data.team,
              "clients": angular.fromJson(localStorage.getItem("roedl-admin-clients"))
            };
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startEditingProcess(proc) {
    this.editProcessValues = angular.fromJson(angular.toJson(proc));
    this.editProcessProcess = true;
  }

  updateProcess(proc) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateClientProcess(proc).then(
      () => {
        this.editProcessProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  addProcess(proc) {
    this.processesToAdd.push(proc);
  }

  removeProcess(proc) {
    this.processesToAdd.find((p, i) => {
      if (p.groupConfiguration.id == proc.groupConfiguration.id) {
        this.processesToAdd.splice(i, 1);
      }
    });
  }

  startAddingProcesses() {
    this.newClientProcess = true;
  }

  addProcesses() {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    var client = angular.fromJson(angular.toJson(this.client));
    var clientPGConfig = {};
    clientPGConfig.clientIds = [client.id];
    clientPGConfig.configs = [];

    this.processesToAdd.forEach(p => {
      clientPGConfig.configs = clientPGConfig.configs.concat(p.processes);
    });
    clientPGConfig.configs.forEach(c => {
      c.processId = c.id;
      c.valueAdded = c.valueAddedByDefault;
      c.hasVolume = c.hasVolumeByDefault;
      c.commentRequired = c.commentRequiredByDefault;
      delete c.valueAddedByDefault;
      delete c.hasVolumeByDefault;
      delete c.commentRequiredByDefault;
      delete c.description;
      delete c.id;
      delete c.includeInReports;
      delete c.processGroupCountryConfigurationId;
      delete c.valueAddedByDefault;
      delete c.name;
    });
    this.Admin.addProcessForClientInTeam(this.$routeParams.teamId, clientPGConfig).then(
      () => {
        this.newClientProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteProcess(proc){
    this.modalConfig = {
      text: "CLIENT_CONFIGUARTIONS.DELETE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        this.Admin.deleteProcessForClientInTeam(this.$routeParams.teamId, this.$routeParams.clientId, proc.groupConfiguration.id).then(
          () => {
            this.init();
          },
          (error) => {
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        //do when "CANCEL" button clicked
      }
    );
  }
}
